import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiUsersService } from '../../../../services/users/api/api-users.service';
import { AlertsService } from '../../../../services/alerts.service';
import { UserBoosterType } from '../../../../enums/users/user-booster-type.enum';

@Component({
  selector: 'app-user-add-booster-modal',
  templateUrl: './user-add-booster-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class UserAddBoosterModalComponent {

  @Input() userId: number = 0;

  @ViewChild('modal') modal!: ModalDirective;

  protected readonly UserBoosterType = UserBoosterType;
  protected readonly isNaN = isNaN;

  isLoading: boolean = false;
  boosterType: UserBoosterType = UserBoosterType.LevelExperience;
  multiplier: number | null = null;
  duration: number | null = null;

  private callbackSaved?: () => void;

  constructor(private apiUsersService: ApiUsersService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.boosterType = UserBoosterType.LevelExperience;
    this.multiplier = null;
    this.duration = null;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiUsersService.addBooster(this.userId, this.boosterType, this.multiplier ?? 0, this.duration ?? 0).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Booster added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding booster : ' + error);
      }
    );
  }
}
